var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('m-panel',{attrs:{"title":_vm.$t('panels.badges.title'),"draggable":"draggable"}})
}
var staticRenderFns = []

export { render, staticRenderFns }